import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

//路由组件
import home from '../pages/home'
import news from '../pages/news'
import slider from '../pages/slider'
import contentt from '../pages/slider/contentt'
import organ from '../pages/slider/organ'
import elist from '../pages/slider/elist'
import detail from '../pages/slider/detail'
import detail2 from '../pages/detail_nomenu'
import party from '../pages/party'
import work from '../pages/work'
import service from '../pages/service'
import special from '../pages/special'
import search from '../pages/search'
import er from '../pages/slider/er'

Vue.component('home',home)
Vue.component('news',news)
Vue.component('slider',slider)
Vue.component('contentt',contentt)
Vue.component('organ',organ)
Vue.component('elist',elist)
Vue.component('detail',detail)
Vue.component('detail_nomenu',detail2)
Vue.component('party',party)
Vue.component('work',work)
Vue.component('service',service)
Vue.component('special',special)
Vue.component('search',search)
Vue.component('er',er)


const routerRePush = VueRouter.prototype.push
VueRouter.prototype.push = function (location) {
  return routerRePush.call(this, location).catch(error => error)
}





const router = new VueRouter({
	routes : [
		{ path: '/', component: home},
		{ path: '/news', component: news},
		{ 
			path: '/slider/:id', 
			component: slider ,
			children:[
				{ path: 'contentt', component: contentt},
				{ path: 'organ', component: organ},
				{ path: 'elist', component: elist,name:''},
				{ path: 'detail', component: detail},
				{ path: 'er', component: er},
			]
		},
		// { path: '/party', component: party },
		// { path: '/detail_nomenu', component: detail2 },
		{ path: '/work', component: work },
		{ path: '/service', component: service},
		{ path: '/search', component: search},
	]
})


//导航守卫
// router.beforeEach((to, from, next) => {
//   // ...
// 	console.log('routerTo',to);
	
// 	next()
// })

router.beforeEach((to,from,next)=>{
    document.documentElement.scrollTop=0
    document.body.scrollTop=0
    next()
})



export default  router